import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.SourceView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'ugc-sources'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/source"]
  labelsTemplate: JST["backbone/templates/monitoring/reports/executive/source_labels"]

  initialize: (@options = {}) ->
    @colors = {
      twitter: '#47bee8'
      facebook: '#4a66a0'
    }
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color
    @brands = [@options.settings.accountLabel.codes[0]].concat (label.codes[0] for label in @options.settings.competitorsLabels)

  render: ->
    @$el.html(@template(brands: @brands))
    @bindChartsReady(1)
    @addSource()
    return this

  addSource: ->
    query = @extendedQuery({first_dimension: 'filtered_labels', second_dimension: 'type',must_be_public_comments: true, labels: @labelFilter(), labels_structure: @labelsStructure()})
    @_addBars(query,"#histogram-source", { callback: @sourceLabels, drillDownFunction: (clickEvent) ->
      {
        type: [clickEvent.point.series.name.toLowerCase()] # This will probably not work for instagram
        labels: [clickEvent.point.code]
      }
    })

  sourceLabels: (response) =>
    brands = {}
    for serie in response.series
      for data in serie.data
        brands[data.name] ||= { twitter: 0, facebook: 0}
        brands[data.name][serie.code] += data.y
    brandsCount = ( { name:key, twitter:brands[key].twitter, facebook:brands[key].facebook } for key of brands )
    @$el.find('.container').append(@labelsTemplate(brands: @mergeResultsAndColors(brandsCount)))

  mergeResultsAndColors: (brandsCount) =>
    brand_colors = @_colorsByBrands()
    _.each(brandsCount, (brand_count) =>
      _.each(brand_colors, (brand_color) =>
        if brand_count['name'] == brand_color['brand']
          brand_count['color'] = brand_color['color']
          brand_count['clearer_color'] = brand_color['clearer_color']
      )
    )
    brandsCount
